import React from "react";
import { useNavigate } from "react-router-dom";
import SvgIcon from "@components/common/SvgIcon/SvgIcon";
import P from "@components/common/P/P";
import { motion } from "framer-motion";

interface NavItemProps {
	icon: any;
	label: string;
	path: string;
	isActive: boolean;
	onNavigate?: () => void;
}

const NavItem = React.memo(
	({ icon, label, path, isActive, onNavigate }: NavItemProps) => {
		const navigate = useNavigate();

		const handleClick = () => {
			onNavigate?.();
			requestAnimationFrame(() => {
				navigate(path);
			});
		};

		return (
			<motion.button
				type="button"
				onClick={handleClick}
				className="relative grid gap-2 px-3 py-2.5 cursor-pointer grid-cols-maxTwo place-items-center"
				initial={{ scale: 1 }}
				whileHover={{ scale: 1.05 }}
				whileTap={{ scale: 0.95 }}
			>
				{isActive && (
					<motion.div
						className="absolute inset-0 z-0 border-b-[3px] bg-light-shadeOne dark:bg-dark-shadeOne rounded-md border-light-mainColor dark:border-dark-mainColor"
						layoutId="activeNavItem"
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						transition={{ type: "spring", stiffness: 300, damping: 20 }}
					/>
				)}

				<SvgIcon
					Icon={icon}
					width={22}
					height={22}
					className={`z-10 ${
						isActive
							? "stroke-light-mainColor dark:stroke-dark-mainColor"
							: "stroke-light-grayThree dark:stroke-dark-grayThree"
					}`}
				/>
				<P
					size="t1"
					type="semibold"
					className={`z-10 cursor-pointer ${
						isActive
							? "text-light-mainColor dark:text-dark-mainColor"
							: "text-light-grayThree dark:text-dark-grayThree"
					}`}
				>
					{label}
				</P>
			</motion.button>
		);
	},
);

export default NavItem;
